import React from "react";
import SpinnerContainer, { SpinnerWrapper } from "./style/SpinnerStyle";

const Spinner = () => {
  return (
    <SpinnerContainer>
      <SpinnerWrapper />
    </SpinnerContainer>
  );
};

export default Spinner;
